(() => {
  if (globalThis.kloveHomePreviewInstalled) return;
  globalThis.kloveHomePreviewInstalled = true;
  const init = () => document.querySelectorAll('[data-home-fabric-preview]').forEach(card => {
    if (card.dataset.ready) return;
    card.dataset.ready = 'true';
    const image = card.querySelector('[data-fabric-preview-image]');
    const link = card.closest('.kd-config__inner')?.querySelector('[data-home-config-link]');
    const status = card.querySelector('[data-fabric-preview-status]');
    const buttons = [...card.querySelectorAll('[data-fabric-src]')];
    const fieldset = card.querySelector('fieldset');
    if (!image || !status || !fieldset) return;
    fieldset.hidden = buttons.length === 0;
    const controller = new AbortController();
    let request = 0;
    buttons.forEach(button => button.addEventListener('click', () => {
      const ticket = ++request;
      const next = new Image();
      status.textContent = card.dataset.loadingLabel;
      next.onload = () => {
        if (ticket !== request || !card.isConnected) return;
        image.sizes = button.dataset.fabricSizes;
        image.srcset = button.dataset.fabricSrcset;
        image.dataset.fullSrc = button.dataset.fabricFullSrc;
        image.src = button.dataset.fabricSrc;
        image.alt = `${card.dataset.modelName} — ${button.dataset.fabricName}`;
        if (link && button.dataset.fabricValue) {
          const target = new URL(link.href);
          target.searchParams.set('fabric', button.dataset.fabricValue);
          link.href = target.href;
        }
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        status.textContent = '';
      };
      next.onerror = () => { if (ticket === request && card.isConnected) status.textContent = card.dataset.errorLabel; };
      next.sizes = button.dataset.fabricSizes;
      next.srcset = button.dataset.fabricSrcset;
      next.src = button.dataset.fabricSrc;
    }, {signal: controller.signal}));
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(card)) return;
      request++;
      controller.abort();
      delete card.dataset.ready;
    }, {signal: controller.signal});
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
